import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { caseStudies } from "../mockData";
import { usePopup } from "../context/PopupContext";

export default function CaseStudies() {
  const { open } = usePopup();
  return (
    <main data-testid="case-studies-page" className="pt-28 pb-16">
      {/* Hero */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <span className="text-purple-400 text-sm font-medium tracking-wider uppercase">Our Work</span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-['Playfair_Display'] text-white mt-4 mb-6">
              Case <span className="gradient-text">Studies</span>
            </h1>
            <p className="text-gray-400 text-base sm:text-lg max-w-2xl mx-auto">
              Explore how we've helped businesses across industries achieve digital transformation with measurable results.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Case Studies Grid */}
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10">
          {caseStudies.map((study, i) => (
            <motion.div
              key={study.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="bg-white/5 border border-purple-900/20 rounded-2xl overflow-hidden card-hover"
            >
              <img src={study.image} alt={study.title} className="w-full h-[200px] sm:h-[280px] object-cover" loading="lazy" />
              <div className="p-8">
                <span className="inline-block bg-purple-600 text-white text-xs px-4 py-1 rounded-full mb-4">
                  by Digitronix Consultancy
                </span>
                <h3 className="text-white font-semibold text-xl mb-3">{study.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-6">{study.description}</p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {study.tags.map((tag) => (
                    <span key={tag} className="bg-white/10 text-gray-300 text-xs px-3 py-1.5 rounded-full border border-purple-900/20">
                      {tag}
                    </span>
                  ))}
                </div>
                <button
                  onClick={open}
                  className="inline-flex items-center gap-2 text-purple-400 hover:text-purple-300 text-sm font-medium transition-colors"
                >
                  Discuss a Similar Project <ArrowRight size={14} />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-4 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-['Playfair_Display'] text-white mb-6">
            Have a project in mind?
          </h2>
          <p className="text-gray-400 max-w-lg mx-auto mb-8">
            We'd love to hear about your challenges and explore how our expertise can drive results for your business.
          </p>
          <button onClick={open} className="inline-flex items-center gap-2 cta-button text-white px-8 py-4 rounded-full text-base font-semibold" data-testid="case-studies-cta">
            Let's Talk <ArrowRight size={18} />
          </button>
        </div>
      </section>
    </main>
  );
}
